import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function FlagOutline(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M6.833 4.546a1 1 0 01-.014.15L4.187 20h2.199l.583-3.99a.97.97 0 01.005-.032c.374-2.083 1.9-2.968 3.133-3.658a.978.978 0 01.063-.032l8.292-3.897c.241-.126.383-.243.457-.335A.3.3 0 0019 7.848c0-.155-.109-.376-.42-.493L8.397 4.105c-1.134-.27-1.396.053-1.434.1l-.002.002a.693.693 0 00-.128.339zM5.413 2.94c.676-.824 1.836-1.175 3.491-.77a.994.994 0 01.067.019l10.237 3.267.034.011C20.214 5.817 21 6.705 21 7.848c0 1.212-.866 1.933-1.64 2.33a.895.895 0 01-.03.015l-8.277 3.89c-1.233.691-1.913 1.178-2.108 2.233l-.706 4.829A1 1 0 017.25 22H3a1 1 0 01-.986-1.17L4.837 4.418l.007-.079a2.69 2.69 0 01.57-1.398z",
    clipRule: "evenodd"
  }));
}

export default FlagOutline;